module.exports = __webpack_public_path__ + "static/logo-73f900a4fdb0677ecefa1a96dea6aed2.png";